import React from 'react';
import IntlTelInput from 'react-intl-tel-input';

export default (props) => {
  const { disabled, ...otherProps } = props;
  
  return (
    <>
      <IntlTelInput
        onPhoneNumberChange={props.onChange}
        onPhoneNumberBlur={props.onBlur}
        preferredCountries={props.preferredCountries || ['sa', 'eg', 'ps']}
        disableCountryCode
        onlyCountries={props.onlyCountries}
        inputClassName="tel-input"
        containerClassName="tel-input-container intl-tel-input tel-wrapper"
        {...otherProps}
        {...(disabled && { placeholder: 'يرجى إكمال التحقق من لست روبوت' })}
        disabled={disabled}
      />
    </>
  );
};